import { render, staticRenderFns } from "./facebook-login.vue?vue&type=template&id=f6d39346&"
import script from "./facebook-login.vue?vue&type=script&lang=js&"
export * from "./facebook-login.vue?vue&type=script&lang=js&"
import style0 from "./facebook-login.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports